export enum WebCrawlStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum FieldStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum SiteResultStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED'
}

export enum SiRequestStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REVIEWING = 'REVIEWING',
  APPROVING = 'APPROVING',
  SCANNED = 'SCANNED',
  REVIEWED = 'REVIEWED',
  AUTO_DONE = 'AUTO_DONE',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
}

export enum SiRequestAssigneeStatus {
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
}

export enum SiService {
  DOMAIN_SIFT_SERVICE = 'DOMAIN_SIFT_SERVICE',
  DATA_SIFT_SERVICE = 'DATA_SIFT_SERVICE',
  ADULT_SHIELD_SERVICE = 'ADULT_SHIELD_SERVICE',
  TOBACCO_SIFT_SERVICE = 'TOBACCO_SIFT_SERVICE',
  BRAND_DETECT_SERVICE = 'BRAND_DETECT_SERVICE',
  INBOUND_FLOW_SERVICE = 'INBOUND_FLOW_SERVICE',
  OUTBOUND_FLOW_SERVICE = 'OUTBOUND_FLOW_SERVICE',
  SOCIAL_OUTBOUND_FLOW_SERVICE = 'SOCIAL_OUTBOUND_FLOW_SERVICE',
  CUSTOMER_DISPUTE_SERVICE = 'CUSTOMER_DISPUTE_SERVICE',
  TRACE_SERVICE = 'TRACE_SERVICE',
  MEMBERS_ONLY_SIFT_SERVICE = 'MEMBERS_ONLY_SIFT_SERVICE',
  CATEGORIZE_SERVICE = 'CATEGORIZE_SERVICE',
  SI_AI_SERVICE = 'SI_AI_SERVICE'
}

export enum SiteService {
  DOMAIN_SIFT_SERVICE = 'DOMAIN_SIFT_SERVICE',
  DATA_SIFT_SERVICE = 'DATA_SIFT_SERVICE',
  ADULT_SHIELD_SERVICE = 'ADULT_SHIELD_SERVICE',
  TOBACCO_SIFT_SERVICE = 'TOBACCO_SIFT_SERVICE',
  BRAND_DETECT_SERVICE = 'BRAND_DETECT_SERVICE',
  INBOUND_FLOW_SERVICE = 'INBOUND_FLOW_SERVICE',
  OUTBOUND_FLOW_SERVICE = 'OUTBOUND_FLOW_SERVICE',
  SOCIAL_OUTBOUND_FLOW_SERVICE = 'SOCIAL_OUTBOUND_FLOW_SERVICE',
  CUSTOMER_DISPUTE_SERVICE = 'CUSTOMER_DISPUTE_SERVICE',
  TRACE_SERVICE = 'TRACE_SERVICE',
  MEMBERS_ONLY_SIFT_SERVICE = 'MEMBERS_ONLY_SIFT_SERVICE',
  CATEGORIZE_SERVICE = 'CATEGORIZE_SERVICE',

  FRAUD_SHIELD_SERVICE = 'FRAUD_SHIELD_SERVICE',
  SI_AI_SERVICE = 'SI_AI_SERVICE'
}

export enum KeywordType {
  ADULT = 'ADULT',
  ALCOHOL = 'ALCOHOL',
  CASINO = 'CASINO',
  CHARITY = 'CHARITY',
  CRYPTOCURRENCY = 'CRYPTOCURRENCY',
  DATING = 'DATING',
  FINANCIAL = 'FINANCIAL',
  GAMING = 'GAMING',
  HEALTH = 'HEALTH',
  IPTV = 'IPTV',
  LIVE_STREAM = 'LIVE_STREAM',
  SPORT_JERSEYS = 'SPORT_JERSEYS',
  VOUCHER = 'VOUCHER',
  VPN = 'VPN',
  WEAPON = 'WEAPON',
  FIREWORK = 'FIREWORK',
  E_BOOK = 'E_BOOK',
  // MOVIE = 'MOVIE',
  // VIDEO = 'VIDEO',
  // MUSIC = 'MUSIC',
  DUMMY = 'DUMMY',
  // BLOG = 'BLOG',
  // FORUM = 'FORUM',
  // NEWS = 'NEWS',
  CMS = 'CMS',
  PHARMACY = 'PHARMACY',
  MEDICAL_DEVICE_AND_ACCESSORY = 'MEDICAL_DEVICE_AND_ACCESSORY',
  GAME_ASSET = 'GAME_ASSET',
  AI_GENERATED_MEDIA = 'AI_GENERATED_MEDIA',
  BLIND_BOX = 'BLIND_BOX',
  CELEBRITY = 'CELEBRITY',
  INVALID_SITE_TITLE = 'INVALID_SITE_TITLE',
}

const StatisticCategories = {
  ...KeywordType,
  RESTRICTED_ADULT: 'RESTRICTED_ADULT',
  TOBACCO: 'TOBACCO',
  MEMBERS_ONLY: 'MEMBERS_ONLY',
} as const;

export type StatisticCategory = typeof StatisticCategories[keyof typeof StatisticCategories];

export enum DataSiftField {
  COMPANY_NAME = 'COMPANY_NAME',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  ADDRESS = 'ADDRESS',
  POLICY = 'POLICY',
  MESSENGER = 'WHATSAPP',
}

export enum BrandSector {
  ANIME = 'ANIME',
  AUTOMOBILE = 'AUTOMOBILE',
  CONSUMER_GOODS = 'CONSUMER_GOODS',
  COSMETICS = 'COSMETICS',
  ELECTRONICS = 'ELECTRONICS',
  ENERGY = 'ENERGY',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FASHION = 'FASHION',
  FITNESS = 'FITNESS',
  FOOD_AND_BEVERAGE = 'FOOD_AND_BEVERAGE',
  MUSICAL_INSTRUMENTS = 'MUSICAL_INSTRUMENTS',
  OTHER = 'OTHER',
  PHARMACEUTICALS = 'PHARMACEUTICALS',
  SPORTS_EQUIPMENT = 'SPORTS_EQUIPMENT',
  TOYS = 'TOYS',
}

export enum BrandStatus {
  ACTIVE = 'AUTO_DETECTED',
  EXCLUDED = 'NOT_DETECTED',
  PENDING = 'PENDING',
}

export enum Vpn {
  US = 'US',
  EU = 'EU',
  ASIA = 'ASIA',
}

export enum CategorizeServiceSection {
  BRAND = 'BRAND',
  CATEGORY = 'CATEGORY',
}

export enum FrequencyType {
  NOW = 'NOW',
  ONE_TIME = 'ONE_TIME',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BI_WEEKLY = 'BI_WEEKLY',
  MONTHLY = 'MONTHLY',
  BI_MONTHLY = 'BI_MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export enum CustomFrequencyType {
  CUSTOM_OCBC = 'CUSTOM_OCBC'
}

export enum ScheduleEndType {
  COUNT = 'COUNT',
  DATE = 'DATE',
  NO_END = 'NO_END'
}

export enum ScheduleRequestStatus {
  PENDING = 'PENDING',
  SCHEDULED = 'SCHEDULED',
  FINISHED = 'FINISHED',
  ERROR = 'ERROR',
}

export enum ScheduleScanStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum RemarkOptionType {
  GENERAL = 'GENERAL',
  SPECIFIC = 'SPECIFIC',
}

export enum RemarkOptionLabel {
  MEMBERS_ONLY = 'MEMBERS_ONLY',
  MISSING_TERMS_AND_POLICIES = 'MISSING_TERMS_AND_POLICIES',
  MISSING_CONTACT_INFORMATION = 'MISSING_CONTACT_INFORMATION',
  MISSING_COMPANY_NAME = 'MISSING_COMPANY_NAME',
  MISSING_PHONE = 'MISSING_PHONE',
  MISSING_EMAIL = 'MISSING_EMAIL',
  MISSING_ADDRESS = 'MISSING_ADDRESS',
  UNKNOWN_ON_INTERNET = 'UNKNOWN_ON_INTERNET',
  REDIRECT_SITE = 'REDIRECT_SITE',
  SITE_UNAVAILABLE = 'SITE_UNAVAILABLE',
  NOT_FULLY_FUNCTIONAL_SITE = 'NOT_FULLY_FUNCTIONAL_SITE',
  SELLING_BRANDED_ITEMS = 'SELLING_BRANDED_ITEMS',
  CROWDFUNDING_DONATIONS = 'CROWDFUNDING_DONATIONS',
  FIREWORKS = 'FIREWORKS',
  POTENTIAL_IP_INFRINGEMENT = 'POTENTIAL_IP_INFRINGEMENT',
  RELATED_SITE = 'RELATED_SITE',
  CUBAN_CIGARS = 'CUBAN_CIGARS',
  MCC_MISCODED = 'MCC_MISCODED',
  UNUSUAL_WEBSITE_TITLE_OR_DESCRIPTION = 'UNUSUAL_WEBSITE_TITLE_OR_DESCRIPTION',
  EMAIL_DOMAIN_MISMATCH = 'EMAIL_DOMAIN_MISMATCH',
}

export enum RemarkOptionStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum QuotaStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ScheduleUrlLimitSetting {
  UNIQUE = 'UNIQUE',
  MULTIPLE = 'MULTIPLE',
}

export const allSiteIntelligenceServices = [
  ...Object.values(SiService),
  ...Object.values(SiteService),
];
export type SiteIntelligenceService = keyof typeof SiService | keyof typeof SiteService;

export const siteIntelligenceServiceLabel: Record<SiteIntelligenceService, string> = {
  [SiService.DOMAIN_SIFT_SERVICE]: 'Domain',
  [SiService.DATA_SIFT_SERVICE]: 'Contact',
  [SiService.ADULT_SHIELD_SERVICE]: 'Adult',
  [SiService.TOBACCO_SIFT_SERVICE]: 'Tobacco',
  [SiService.BRAND_DETECT_SERVICE]: 'Brand',
  [SiService.INBOUND_FLOW_SERVICE]: 'Inbound',
  [SiService.OUTBOUND_FLOW_SERVICE]: 'Outbound',
  [SiService.SOCIAL_OUTBOUND_FLOW_SERVICE]: 'Social Media',
  [SiService.CUSTOMER_DISPUTE_SERVICE]: 'Complaints',
  [SiService.TRACE_SERVICE]: 'Related Identity',
  [SiService.MEMBERS_ONLY_SIFT_SERVICE]: 'Members Only',
  [SiteService.FRAUD_SHIELD_SERVICE]: 'IP / Email',
  [SiteService.CATEGORIZE_SERVICE]: 'Sensitive Category',
  [SiteService.SI_AI_SERVICE]: 'SI AI Service',
};

export const keywordLabel: Record<KeywordType, string> = {
  [KeywordType.ADULT]: 'Keyword Adult',
  [KeywordType.ALCOHOL]: 'Alcohol',
  [KeywordType.CASINO]: 'Casino',
  [KeywordType.CHARITY]: 'Charity',
  [KeywordType.CRYPTOCURRENCY]: 'Cryptocurrency',
  [KeywordType.DATING]: 'Dating',
  [KeywordType.FINANCIAL]: 'Financial',
  [KeywordType.GAMING]: 'Gaming',
  [KeywordType.HEALTH]: 'Health',
  [KeywordType.IPTV]: 'IPTV',
  [KeywordType.LIVE_STREAM]: 'Live Stream',
  [KeywordType.SPORT_JERSEYS]: 'Sport Jerseys',
  [KeywordType.VOUCHER]: 'Voucher',
  [KeywordType.VPN]: 'VPN',
  [KeywordType.WEAPON]: 'Weapon',
  [KeywordType.FIREWORK]: 'Firework',
  [KeywordType.E_BOOK]: 'E-Book',
  // [KeywordType.MOVIE]: 'Movie',
  // [KeywordType.VIDEO]: 'Video',
  // [KeywordType.MUSIC]: 'Music',
  [KeywordType.DUMMY]: 'Dummy',
  // [KeywordType.BLOG]: 'Blog',
  // [KeywordType.FORUM]: 'Forum',
  // [KeywordType.NEWS]: 'News',
  [KeywordType.CMS]: 'Content Management System',
  [KeywordType.PHARMACY]: 'Pharmacy',
  [KeywordType.MEDICAL_DEVICE_AND_ACCESSORY]: 'Medical Device / Accessory',
  [KeywordType.GAME_ASSET]: 'Game Asset',
  [KeywordType.AI_GENERATED_MEDIA]: 'AI Generated Media',
  [KeywordType.INVALID_SITE_TITLE]: 'Invalid Site Title',
  [KeywordType.CELEBRITY]: 'Celebrity',
  [KeywordType.BLIND_BOX]: 'Blind Box',
};

export const vpnLabel: Record<Vpn, string> = {
  [Vpn.US]: 'SI_DOMAIN.INSPECTED_VIA_USA',
  [Vpn.EU]: 'SI_DOMAIN.INSPECTED_VIA_EUROPE',
  [Vpn.ASIA]: 'SI_DOMAIN.INSPECTED_VIA_ASIA',
};

export enum SiRequestType {
  SI = 'SI',
  API = 'API',
  TLD = 'TLD',
}

export const getVpnLabel = (
  vpnText: string,
  formatMessage?: (descriptor: { id: string }) => string
): string => {
  if (!vpnText) return '';

  const vpn = vpnText.toUpperCase();

  const resolveLabel = (labelId: string) =>
    formatMessage ? formatMessage({ id: labelId }) : labelId;

  const mappedVpn = Vpn[vpn];
  if (mappedVpn) return resolveLabel(vpnLabel[mappedVpn]);

  if (vpn === 'DEFAULT') return resolveLabel(vpnLabel[Vpn.ASIA]);

  return resolveLabel('SI_DOMAIN.INSPECTED_VIA_OTHER_REGION');
};

export const sexualCategoryLabel: Record<string, string> = {
  'general-sexual-content': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.GENERAL_SEXUAL_CONTENT',
  'age-restricted-content': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.AGE_RESTRICTED_CONTENT',
  'age-restricted-content-hidden': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.AGE_RESTRICTED_CONTENT_HIDDEN',
  'sexualized-drug-use': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEXUALIZED_DRUG_USE',
  'sex-rape': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_RAPE',
  'sex-sm': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_SM',
  'sex-incest': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_INCEST',
  'sex-csam': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_CSAM',
  'sex-violence': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_VIOLENCE',
  'sex-doll': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_DOLL',
  'sex-beastiality': 'SI_CATEGORY_DETAIL.SEXUAL_CATEGORY.SEX_BEASTIALITY',
};

export const getSexualCategoryLabel = (
  category: string,
  formatMessage?: (descriptor: { id: string }) => string
): string => {
  const labelId = sexualCategoryLabel?.[category];
  if (!labelId) return category;
  return formatMessage ? formatMessage({ id: labelId }) : labelId;
};

export const normalizeVpn = (vpn: string): Vpn => {
  const mappedVpn = Vpn[vpn.toUpperCase()];
  if (mappedVpn) return mappedVpn;
  else return Vpn.ASIA;
};

export const queueIdInSavingRemarkOptionCaptures = 'remark_options';

export const categoryLabelMap: Record<StatisticCategory, string> = {
  ADULT: 'adult content',
  ALCOHOL: 'alcoholic',
  CASINO: 'casino',
  CHARITY: 'charity',
  CRYPTOCURRENCY: 'cryptocurrency',
  DATING: 'dating - high-brand risk',
  FINANCIAL: 'financial',
  GAMING: 'gaming',
  HEALTH: 'health',
  IPTV: 'iptv',
  LIVE_STREAM: 'live stream',
  VOUCHER: 'voucher',
  VPN: 'vpn',
  WEAPON: 'weapon',
  FIREWORK: 'fireworks',
  SPORT_JERSEYS: 'sport jerseys',
  PHARMACY: 'pharmacy',
  MEDICAL_DEVICE_AND_ACCESSORY: 'medical device / accessory',
  GAME_ASSET: 'game asset',
  AI_GENERATED_MEDIA: 'ai generated media',
  BLIND_BOX: 'blind box',
  E_BOOK: 'e-book',
  // MOVIE: 'movie',
  // VIDEO: 'video',
  // MUSIC: 'music',
  DUMMY: 'dummy',
  // BLOG: 'blog',
  // FORUM: 'forum',
  // NEWS: 'news',
  CMS: 'content management system',
  RESTRICTED_ADULT: 'adult content',
  TOBACCO: 'tobacco',
  MEMBERS_ONLY: 'members only',
  CELEBRITY: 'celebrity',
  INVALID_SITE_TITLE: 'invalid site title',
}

export const siAiCategoryReasonTranslationKey: Record<StatisticCategory, string> = {
  [KeywordType.ADULT]: '',
  [KeywordType.ALCOHOL]: 'alcoholic_reason',
  [KeywordType.CASINO]: 'casino_reason',
  [KeywordType.CHARITY]: 'charity_reason',
  [KeywordType.CRYPTOCURRENCY]: 'cryptocurrency_reason',
  [KeywordType.DATING]: 'dating_reason',
  [KeywordType.FINANCIAL]: 'financial_reason',
  [KeywordType.GAMING]: 'game_reason',
  [KeywordType.HEALTH]: 'supplement_reason',
  [KeywordType.IPTV]: 'iptv_reason',
  [KeywordType.LIVE_STREAM]: 'live_stream_reason',
  [KeywordType.SPORT_JERSEYS]: 'sport_jersey_reason',
  [KeywordType.VOUCHER]: 'voucher_reason',
  [KeywordType.VPN]: 'vpn_reason',
  [KeywordType.WEAPON]: 'weapon_reason',
  [KeywordType.FIREWORK]: 'firework_reason',
  [KeywordType.E_BOOK]: '',
  // [KeywordType.MOVIE]: 'Movie',
  // [KeywordType.VIDEO]: 'Video',
  // [KeywordType.MUSIC]: 'Music',
  [KeywordType.DUMMY]: 'dummy_reason',
  // [KeywordType.BLOG]: 'Blog',
  // [KeywordType.FORUM]: 'Forum',
  // [KeywordType.NEWS]: 'News',
  [KeywordType.CMS]: '',
  [KeywordType.PHARMACY]: 'drug_reason',
  [KeywordType.MEDICAL_DEVICE_AND_ACCESSORY]: 'medical_device_reason',
  [KeywordType.GAME_ASSET]: 'game_asset_reason',
  [KeywordType.AI_GENERATED_MEDIA]: 'ai_image_related_reason',
  [KeywordType.INVALID_SITE_TITLE]: '',
  [KeywordType.CELEBRITY]: 'celebrity_reason',
  [KeywordType.BLIND_BOX]: 'blind_box_reason',
  [StatisticCategories.TOBACCO]: 'tobacco_reason',
  [StatisticCategories.MEMBERS_ONLY]: '',
  [StatisticCategories.RESTRICTED_ADULT]: 'restrict_adult_reason',
}

export const siAiAdultCategoryReasonTranslationKey: Record<string, string> = {
  'general-sexual-content': 'restrict_adult.general_sexual_content_reason',
  'sexualized-drug-use': 'sexualized_drug_use_reason',
  'sex-rape': 'sex_rape_reason',
  'sex-sm': 'sex_sm_reason',
  'sex-incest': 'sex_incest_reason',
  'sex-csam': 'sex_csam_reason',
  'sex-violence': 'sex_violence_reason',
  'sex-doll': 'sex_doll_reason',
  'sex-beastiality': 'sex_beastiality_reason',
};